import React from 'react';
import './ComoFuncionaSection.css';

const ComoFuncionaSection = () => {
  return (
    <section className="como-funciona-section">
      <div className="como-funciona-content">
        <h2 className="como-funciona-title">Como funciona</h2>
        
        <div className="como-funciona-steps">
          <div className="step-item">
            <div className="step-number">1</div>
            <h3 className="step-title">Encontre e seja encontrado</h3>
            <p className="step-description">
              Tutores buscam parceiros no mapa. Parceiros recebem clientes qualificados.
            </p>
          </div>
          
          <div className="step-item">
            <div className="step-number">2</div>
            <h3 className="step-title">Agende e valide</h3>
            <p className="step-description">
              Agendamento pelo app e validação rápida por QR Code no atendimento.
            </p>
          </div>
          
          <div className="step-item">
            <div className="step-number">3</div>
            <h3 className="step-title">Avalie e repita</h3>
            <p className="step-description">
              Avaliações constroem reputação. Clientes satisfeitos voltam sempre.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComoFuncionaSection;

